import React, { useState } from 'react'
import { useLocation } from "react-router-dom";

export default function Login(props) {
    const apiLoginUrl = `${process.env.REACT_APP_CSAPI_BASE_URL}/auth/agent/login`;
    const location = useLocation();    
    
    const [input, setInput] = useState({
        email: "",
        password: ""
    })
    const [buttonText, setButtonText] = useState('Login');

    const [errorvalid, seterrorvalid] = useState(false);

    const [errorCatchMessage, setErrorCatchMessage] = useState("");
    
    const handleLogin = (e) => {
        e.preventDefault();
        //const loggeduser = JSON.parse(localStorage.getItem("user"));
        setButtonText("Please Wait...")

        fetch (apiLoginUrl, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                  },
                body: JSON.stringify({
                    user: input.email,
                    secret: input.password
                }),
        })
        .then(response => {           
            if(response.status >= 400) {
                throw new Error("Server responds with error!");
            }
            return response.json();
        })
        .then((result) => {
            if(result.status === "error"){
                setButtonText("Login")
                seterrorvalid(true);
                localStorage.removeItem("loggedIn");
            } else {
                seterrorvalid(false);
                const d = new Date();
                const expirytime = d.setMinutes(d.getMinutes() + 120); //add 60 mins and convert into milliseconds
                localStorage.setItem('exp', expirytime);
                localStorage.setItem('accessToken', result.token);
                localStorage.setItem('loggedInName', result.name);
                localStorage.setItem("loggedIn",true);
                //navigate("/")
                if(props.reLogin === 1) {
                    window.location.href=location.pathname;
                }
                else {
                    window.location.href="/"
                }
            }
        },
        err => {
                setButtonText("Login")
                setErrorCatchMessage(err.message);
            }
        )
              
    }

  return (
    <>
        <div className="row justify-content-center">
            <div className="col-md-6 col-lg-5">
                <div className="login-wrap p-4 p-md-5">
                <h2 className="text-center mb-4 text-primary">Login</h2>
                {errorvalid &&
                    <div className="alert alert-danger fade show">
                    Invalid Email or Password {errorCatchMessage}                
                    </div>
                }
                <form onSubmit={handleLogin}>
                    <div className="form-floating mb-3 form-group d-flex">
                    <input type="email" className="form-control" id="InputEmail" placeholder="name@example.com"
                    name="email"
                    value={input.email}
                    onChange={(e) =>
                        setInput({
                            ...input,
                            [e.target.name]: e.target.value
                        })
                    } />
                    <label htmlFor="InputEmail">Email address</label>
                    </div>
                                       
                    <div className="form-floating">
                    <input type="password" className="form-control" id="InputPassword" placeholder="Password"
                        name="password"
                        value={input.password}
                        onChange={(e) =>
                            setInput({
                                ...input,
                                [e.target.name]: e.target.value
                            })
                        } />
                    <label htmlFor="InputPassword">Password</label>
                    </div>
                    
                    <div className="my-3 d-grid">
                        <button className="btn btn-primary" type="submit">{buttonText}</button>
                    </div>
                </form>
                </div>
            </div>
        </div>
  </>    
  )
}
